module.exports = __webpack_public_path__ + "img/logo_big.a57d5220.png";